import type { ITsdNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createTsdNote,
  updateNote: updateTsdNote,
  deleteNote: deleteTsdNote,
} = makeNoteService<ITsdNote>('/api/tsdnotes', 'tsdNote')
